import React from 'react'
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom'
import Home from '../Home'
import Login from '../Login'
import NotFound from '../NotFound'
import Dashboard from '../Dashboard'
import SellerList from '../SellerList'
import SellerForm from '../SellerForm'
import ActionList from '../ActionList'
import ActionForm from '../ActionForm'
import UserList from '../UserList'
import UserForm from '../UserForm'
import RoleList from '../RoleList'
import RoleForm from '../RoleForm'
import PrivateRoute from '../../components/PrivateRoute'
import CryptoJS from 'crypto-js'
import config from '../../config/index'

import './index.less'

export default class App extends React.Component {
  render() {
    const userId = CryptoJS.AES.decrypt(localStorage.getItem('userId') ? localStorage.getItem('userId') : '', config.api.cryptoKey).toString(CryptoJS.enc.Utf8)
    const fullAccess = userId === '5' || userId === '1'|| userId === '27' || userId === '28' || userId === '29'

    return (
      <BrowserRouter>
        <Switch>
          <Route exact path='/' component={() => <Redirect to='/admin/dashboard' />} />
          <Route exact path='/login' component={Login} />
          <PrivateRoute exact path='/admin' component={() => <Redirect to='/admin/dashboard' />} />
          <PrivateRoute exact path='/admin/dashboard' component={Dashboard} />
          <PrivateRoute exact path='/admin/sellers' component={SellerList} />
          <PrivateRoute exact path='/admin/sellers/create' component={props => <SellerForm {...props} type='create' />} />
          <PrivateRoute exact path='/admin/sellers/edit/:itemId' component={props => <SellerForm {...props} type='edit' />} />
          <PrivateRoute exact path='/admin/actions' component={ActionList} />
          <PrivateRoute exact path='/admin/actions/create' component={props => <ActionForm {...props} type='create' />} />
          <PrivateRoute exact path='/admin/actions/edit/:itemId' component={props => <ActionForm {...props} type='edit' />} />
          {fullAccess && (
            <PrivateRoute exact path='/admin/users' component={UserList} />
          )}
          <PrivateRoute exact path='/admin/users/create' component={props => <UserForm {...props} type='create' />} />
          <PrivateRoute exact path='/admin/users/edit/:itemId' component={props => <UserForm {...props} type='edit' />} />
          <PrivateRoute exact path='/admin/roles' component={RoleList} />
          <PrivateRoute exact path='/admin/roles/create' component={props => <RoleForm {...props} type='create' />} />
          <PrivateRoute exact path='/admin/roles/edit/:itemId' component={props => <RoleForm {...props} type='edit' />} />
          <Route component={NotFound} />
        </Switch>
      </BrowserRouter>
    )
  }
}



// WEBPACK FOOTER //
// src/containers/App/index.jsx